import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedStates }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userState = user?.state;

    if (!userState || !allowedStates.includes(userState)) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
